export default "/_next/static/media/Screen-Shot-2021-02-21-at-7.36.47-AM-2-1024x289.6bd3d795a0e565fef8cfd28a332bcee9.png";